export default "__VITE_ASSET__BMCbH8wk__"